module.exports = __webpack_public_path__ + "img/c3.b8cb3338.jpg";